import React, { FC, useEffect, useRef, useState } from 'react'
import { Link } from 'umi'
import { Button, ButtonProps, Popconfirm } from 'antd'
import classNames from 'classnames'

import styles from './index.less'

interface ActionBtnProps extends Omit<ButtonProps, 'type' | 'onClick'> {
    onClick?: () => Promise<void> | void
    type?: 'link'
    stopProgation?: boolean
    black?: boolean
    border?: boolean
    bg?: boolean
    confirm?: any
    primaryColor?: boolean
    hoverPrimary?: boolean
    underline?: boolean
    textWrap?: boolean
    to?: string
}

/**
 * 自动管理加载状态的按钮组件
 *
 * @deprecated 推荐使用 `import { Button } from '@/ui'` 代替，支持自动管理加载状态，属性样式与 antd 的 Button 完全一致
 */
const ActionBtn: FC<ActionBtnProps> = props => {
    const {
        children,
        onClick,
        stopProgation = false,
        type,
        black,
        border,
        bg,
        confirm,
        className,
        primaryColor,
        hoverPrimary,
        underline,
        textWrap,
        ...restProps
    } = props

    const $this = useRef({ isUnmount: false, lock: false })
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        return () => {
            $this.current.isUnmount = true
        }
    }, [])

    const handleClick = async () => {
        if ($this.current.lock) {
            return
        }

        $this.current.lock = true
        setLoading(true)

        try {
            const result = onClick?.()

            if (result?.then) {
                await result
            }
        } catch (e) {
            console.error('catchError', e)
        }
        if ($this.current.isUnmount) {
            return
        }

        setLoading(false)
        $this.current.lock = false
    }

    const classes = classNames(
        {
            [styles.container]: true,
            [styles.wrap]: true,
            [styles.border]: border,
            [styles.black]: black,
            [styles.noBorder]: !border,
            [styles.bg]: bg,
            [styles.primaryColor]: primaryColor,
            [styles.hoverPrimary]: hoverPrimary,
            [styles.underline]: underline,
            [styles.textWrap]: textWrap,
        },
        className,
    )

    if (type === 'link') {
        const { to, ...rest } = restProps

        if (to) {
            return (
                <Link className={classes} to={to} {...rest}>
                    {children}
                </Link>
            )
        }

        return (
            <a className={classes} rel="noopener noreferrer" {...rest}>
                {children}
            </a>
        )
    }

    if (confirm) {
        return (
            <Popconfirm {...(confirm || {})} onConfirm={handleClick}>
                <Button type="link" loading={loading} className={classes} {...restProps}>
                    {children}
                </Button>
            </Popconfirm>
        )
    }

    return (
        <Button
            type="link"
            loading={loading}
            className={classes}
            onClick={e => {
                if (stopProgation) {
                    e.stopPropagation()
                }
                handleClick()
            }}
            {...restProps}
        >
            {children}
        </Button>
    )
}

export default ActionBtn
